export type Selection =
  | {
      kind: 'block';
      id: string;
      /** rendered instance key (id + repeat suffix) when known from a canvas click */
      key?: string;
    }
  | { kind: 'page'; id: string }
  | null;

export type ActiveDrag =
  | { kind: 'new-block'; blockType: string }
  | { kind: 'move-block'; blockId: string };

/** How saving the document is going. */
export const SAVE_STATE = { saved: 'saved', saving: 'saving', dirty: 'dirty', error: 'error' } as const;
export type SaveState = (typeof SAVE_STATE)[keyof typeof SAVE_STATE];
